import { Container } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import TechnologyPage from "../../../../components/WMS/Technologies/TechnologyPage"

export const Route = createFileRoute("/_layout/WMS/technologies/$technology")({
  component: TechnologyDetailPage,
})

function TechnologyDetailPage() {
  const { technology } = Route.useParams()

  return (
    <Container maxW="9xl">
      <TechnologyPage id={technology} />
    </Container>
  )
}
